import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {devConfig} from "config/config"; // Importing development configuration

/**
 * Class representing a view for filtering sub-providers.
 * @extends JetView
 */
export default class FilterSubProvidersView extends JetView {
    /**
     * Configures the layout of the filter sub-providers view.
     * @returns {Object} The configuration object for the view.
     */
    config(){
        const _ = this.app.getService("locale")._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing input fields for filtering
        const left = {
            margin: 5,
            rows: [{
                margin: 15,
                css: "on-row",
                cols:[
                    {
                        view: "text", name: "Id", type:"number",
                        label: "<span class='icon-id'></span>" + _("Sub Proveedor Id"), labelPosition: "top",
                        placeholder: _("Sub Proveedor Id"),
                        invalidMessage: _("Sub Proveedor Id is required") // Validation message
                    },
                    {
                        view: "text", name: "Name",
                        label: "<span class='icon-user'></span>" + _("Nombre"), labelPosition: "top",
                        placeholder: _("Nombre"),
                        invalidMessage: _("Nombre is required") // Validation message
                    },
                    {
                        view: "richselect", name: "Type",
                        label: _("Tipo"), labelPosition: "top",
                        placeholder: _("Click para seleccionar "),
                        options: [ // Options for the type selection
                            {"id": "null", "value": _("Todos")},
                            {"id": "1", "value": _("Casino")},
                            {"id": "2", "value": _("Live Casino")},
                            {"id": "3", "value": _("PAYMENT")},
                            {"id": "4", "value": _("PAYOUT")}
                        ]
                    }
                ]},{
                margin: 15,
                css: "on-row",
                cols:[
                    {
                        view: "richselect", name: "IsActivate",
                        label: "<span class='icon-state'></span>" + _("Estado"), labelPosition: "top",
                        placeholder: _("Click para seleccionar "),
                        options: [ // Options for activation status
                            {"id": "null", "value": _("Todos")},
                            {"id": "A", "value": _("Activado")},
                            {"id": "I", "value": _("Inactivado")}
                        ]
                    },
                    {id: "grav2", gravity:2, } // Gravity for layout management
                ]}
            ]
        };

        // Second left section for additional filters
        const left2 = {
            margin: 5,
            rows: [{
                margin: 15,
                css: "on-row",
                cols:[
                    {
                        view: "richselect", name: "IsVerified",
                        label: "<span class='icon-verified_user'></span>" + _("Verificado"), labelPosition: "top",
                        placeholder: _("Click para seleccionar "),
                        options: [ // Options for verification status
                            {"id": "null", "value": _("Todos")},
                            {"id": "A", "value": _("Activado")},
                            {"id": "I", "value": _("Inactivado")}
                        ]
                    },
                    {
                        view: "text", name: "Abbreviated",
                        label: _("Abreviado"), labelPosition: "top",
                        placeholder: _("Abreviado"),
                        invalidMessage: _("Abreviado is required") // Validation message
                    },
                    {id: "grav3", gravity:1, } // Gravity for layout management
                ]}
            ]
        };

        // Upper section of the form
        const upper_section = {
            css: "father-container", height: (document.body.offsetWidth < 500) ? 250 : 0,
            rows:[{
                margin: 10,
                cols: [
                    left, // Including the left section
                ]
            }]
        };

        // Second upper section for additional filters
        const upper_section2 = {
            css: "father-container", height: (document.body.offsetWidth < 500) ? 130 : 0,
            rows:[{
                margin: 10,
                cols: [
                    left2 // Including the second left section
                ]
            }]
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: "b5",
            rows: [
                {
                    multi: true,
                    view: "accordion",
                    css: "betShop",
                    collapsed: true,
                    paddingY: 10,
                    type: "clean",
                    rows: [
                        {
                            header: _("Filtros Avanzados"), body: {
                                padding:10,
                                rows: [upper_section2] // Including the second upper section
                            }
                        }
                    ]
                }
            ]
        };

        // Button section for actions
        const buttons = {
            id:"b2",
            rows:[{
                margin:10,
                responsive: "b2",
                cols:[
                    { id: "grav", gravity:4 }, // Gravity for layout management
                    {
                        minWidth: 220, view:"button", value:_("Añadir Subproveedor"), hidden:!devConfig.getPermAction("ProvidersAdd", "Add"), css:"prm-ProvidersAdd", type:"form", width: (screen == "small") ? 0 : 200,
                        click:()=> { // Click event for adding a sub-provider
                            this.app.callEvent("addProvider:button",[[]]);
                            console.log('Modal Añadir Subproveedor') // Log action
                        }
                    },
                    {
                        minWidth: 200, view:"button", value:_("Limpiar"), width: (screen == "small") ? 0 : 100,
                        click:() => { // Click event for clearing the form
                            this.getRoot().clear();
                        }
                    },
                    {
                        minWidth: 200, view:"button", value:_("Consultar"), type:"form", width: (screen == "small") ? 0 : 100,
                        click:() => { // Click event for filtering providers
                            const filterdata = this.getRoot().getValues(); // Get form values
                            this.app.callEvent("providers:filter",[filterdata]); // Trigger filter event
                            $$("b1").collapse(); // Collapse the accordion
                            $$('a5').scrollTo(100,0); // Scroll to a specific position
                        }
                    }
                ]
            }]
        };

        // Main accordion section for filters
        const accordion_section1 = {
            type: "wide",
            rows: [
                {
                    multi: true,
                    view: "accordion",
                    css: "betShop",
                    collapsed: true,
                    type: "clean",
                    rows: [
                        {
                            header: _("Filtros"), id: "b1", body: {
                                padding: 10,
                                rows: [upper_section, accordion_section,buttons] // Including all sections
                            }
                        }
                    ]
                }
            ]
        };

        // Return the complete form configuration
        return {
            view:"form",
            type: "clean",
            rows:[
                accordion_section1 // Including the main accordion section
            ],
            rules:{
                "fname":webix.rules.isNotEmpty // Validation rule for the form
            }
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        webix.ready(function(){
            if (screen.width < 500){ // Check for small screen size
                $$("grav").hide(); // Hide elements for small screens
                $$("grav2").hide();
                $$("grav3").hide();
            }
        });
    }
}

// FILE DOCUMENTED
